import Controller, {OnMount} from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController'
import {RootAliases, FragmentNames} from '../../../codegen';
import { Inject } from '@odinjs/odin';
import { AvatarAPI } from '@philips-internal/oswald-ui-components';

@Controller({ component: RootAliases.MAIN_LAYOUT, fragment: FragmentNames.ROOT })
export default class RootController extends BaseController {

  @Inject(RootAliases.AVATAR_ROOT)
  avatarAPI!: AvatarAPI;

  @OnMount(RootAliases.AVATAR_ROOT)
  handleMountAvatar(): void {
    const desktopNotSupported = '../../../../resources/assets/desktop_not_supported.svg';
    this.avatarAPI.setImage(desktopNotSupported);
  }
}